import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IStartEnglishIqSessionV2Request } from './start-english-iq-session-v2-request';
import type { IStartEnglishIqSessionV2Response } from './start-english-iq-session-v2-response';
import { startEnglishIqSessionV2ResponseSchema } from './start-english-iq-session-v2-response';

export async function startEnglishIqSessionV2Api(
  body: IStartEnglishIqSessionV2Request,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IStartEnglishIqSessionV2Response>> {
  return postRequest<IStartEnglishIqSessionV2Response>({
    body,
    options,
    path: '/english-iq/session/v2',
    schema: startEnglishIqSessionV2ResponseSchema,
  });
}
